import React, { useState } from 'react';
import './AgePopup.css';

const AgePopup = ({ onSave }) => {
  const [selectedAge, setSelectedAge] = useState('');
  const [error, setError] = useState('');

  const ageGroups = [
    { value: '4', label: '4 года' },
    { value: '5', label: '5 лет' },
    { value: '6', label: '6 лет' },
    { value: '7-8', label: '7–8 лет' },
  ];

  const handleSave = () => {
    if (!selectedAge) {
      setError('Пожалуйста, выберите возрастную группу');
      return;
    }
    
    const userData = {
      ageGroup: selectedAge,
    };
    
    // Сохраняем локально (чтобы попап не вылезал сразу снова)
    localStorage.setItem('ezspeech_user', JSON.stringify(userData));
    // Передаем данные наверх (в App.js)
    onSave(userData);
  };

  return (
    <div className="age-popup-overlay">
      <div className="age-popup">
        <div className="age-popup-header">
          <h2>Возраст ребенка для оценки</h2>
          <p className="age-popup-subtitle" style={{ fontSize: '14px', lineHeight: '1.5', marginTop: '12px' }}>
            Выберите возраст, по нормам которого будет оцениваться ребенок. Если у ребенка есть особенности развития, выберите возраст, соответствующий предполагаемому возрасту развития, а не биологическому.
          </p>
        </div>

        <div className="age-popup-body">
          <div className="form-group">
            <label>Возрастная группа</label>
            <div className="age-grid">
              {ageGroups.map((age) => (
                <button
                  key={age.value}
                  className={`age-btn ${selectedAge === age.value ? 'active' : ''}`}
                  onClick={() => {
                    setSelectedAge(age.value);
                    setError('');
                  }}
                >
                  {age.label}
                </button>
              ))}
            </div>
          </div>

          {error && <p className="error-text">{error}</p>}
        </div>

        <div className="age-popup-footer">
          <button className="save-btn" onClick={handleSave}>
            Сохранить и начать тест →
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgePopup;